export const routesList: { [key: string]: string } = {
  home: 'Início',
  duvidas_frequentes: 'Dúvidas frequentes',
  orientacoes_sobre_execucao_fiscal: 'Orientações sobre execução fiscal',
  atendimentos_especializados: 'Atendimentos especializados',
  servicos: 'Serviços',
  em_aberto: 'Consultar dívidas',
  parcelamentos: 'Consultar parcelamentos',
  protestos: 'Títulos protestados',
  validar_documento: 'Validar assinatura',
  pix: 'Pagamento via Pix',
  noticias: 'Notícias',
  noticia: 'Portal PGM está de cara nova',
  atendimento_sem_sair_de_casa: 'Atendimento sem sair de casa',
  transacao_tributaria: 'Transação tributária',
  fundef_fundeb: 'FUNDEF e FUNDEB',
  refis_2025: 'Refis 2025',
  fundef_agreement: 'Acordo do Fundef',
  valeria_lopes_publica_artigo_em_jornal: 'Artigo de Valéria Lopes',
  pgm_birthday: 'Aniversário da PGM',
  area_atendente: 'Área do atendente',
  contatos: 'Contatos',
  duvidas: 'Dúvidas frequentes',
  login: 'Área do Atendente',
  'admin/login': 'Portal Admin',
  apgm: 'Institucional: Sobre a PGM',
  quem_e_quem: 'Institucional: Quem é quem',
  leis_regulamentadoras: 'Institucional: Leis regulamentadoras',
  transparencia: 'Institucional: Transparência',
  video_call: 'Videochamada',
  new_view: 'Nova página',
  pagina_nao_encontrada: 'Página não encontrada',
};

export interface RouteParent {
  key: string;
  path: string;
}

const routeParents: { [key: string]: RouteParent } = {
  em_aberto: { key: 'servicos', path: '/servicos' },
  parcelamentos: { key: 'servicos', path: '/servicos' },
  protestos: { key: 'servicos', path: '/servicos' },
  validar_documento: { key: 'servicos', path: '/servicos' },
  pix: { key: 'servicos', path: '/servicos' },
  noticia: { key: 'noticias', path: '/noticias' },
  atendimento_sem_sair_de_casa: { key: 'noticias', path: '/noticias' },
  transacao_tributaria: { key: 'noticias', path: '/noticias' },
  fundef_fundeb: { key: 'noticias', path: '/noticias' },
  refis_2025: { key: 'noticias', path: '/noticias' },
  fundef_agreement: { key: 'noticias', path: '/noticias' },
  valeria_lopes_publica_artigo_em_jornal: { key: 'noticias', path: '/noticias' },
  pgm_birthday: { key: 'noticias', path: '/noticias' },
};

function normalizeRoute(value: string): string {
  return value.replace(/-/g, '_');
}

export function translateRoute(value: string): string | undefined {
  return routesList[normalizeRoute(value)];
}

export function getRouteParent(value: string): RouteParent | undefined {
  return routeParents[normalizeRoute(value)];
}
